import { useQuery, UseQueryResult } from '@tanstack/react-query';
import {
	ManpowerVendorsApiService,
	ListVendorsResponse,
	ListVendorsParams,
} from '../../../services/manpowerVendorsApi';

/**
 * List vendors for the Manpower P&L module.
 * City scoping is automatic from the logged-in user; pass cityId only to narrow further.
 */
export const useVendorData = (
	params?: ListVendorsParams
): UseQueryResult<ListVendorsResponse, Error> => {
	return useQuery({
		queryKey: ['manpower', 'vendors', 'listing', params?.cityId],
		queryFn: async (): Promise<ListVendorsResponse> => {
			return ManpowerVendorsApiService.listVendors(params);
		},
		staleTime: 0,
		gcTime: 0,
		refetchOnMount: true,
		refetchOnWindowFocus: false,
		retry: 1,
	});
};
